import React from "react";
import styled from "styled-components/native";
import { Button } from "cci-component";
import { withRouter } from "cci-utility";
import ImmutableList from "./ImmutableList";

/* Round add button shown on the bottom left of the list */
const AddButton = styled(Button)`
  position: absolute;
  ${props => (props.theme.addButtonRight ? "right" : "left") + ": 30px;"}
  bottom: 30px;
  width: ${props => props.theme.addButtonWidth || "60px"};
  height: ${props => props.theme.addButtonHeight || "60px"};
`;

/**
 * Mutable version of the list component that on top of the features included in ImmutableList, allows the user to change the data
 * by adding new records (add button on the bottom left of the screen).
 *
 * Props:
 * - newUrl: URL to navigate to when the user taps the add button.
 */
const MutableList = ({ history, newUrl, ...restProps }) => (
  <ImmutableList
    {...restProps}
    fixedFooter={() => (
      <AddButton
        ui="round"
        leftIcon="plus"
        onPress={() => history.push(newUrl)}
      />
    )}
  />
);

export default withRouter(MutableList);
